export const createProgramListFormInitialValue: CreateProgramListFormValues = {
    programName: '',
    organisationName: '',
    link: '',
    description: '',
    endDate: '',
    industry: [],
    programType: [],
    banner: {
        url: ''
        // height: 150,
        // width: 400
    }
}

export type CreateProgramListFormValues = {
    companyId?:string;
    userId?:string;
    programName?: string;
    organisationName?: string;
    link?: string;
    description?: string;
    endDate?: string;
    industry?: string[];
    programType?: string[];
    banner?: {
        url: string;
        // height: number;
        // width: number;
    };
};
